<div class="wrap-popup">
  <div class="header">
    <div class="que-info">
        <que-logo-display [isPopup]="true"></que-logo-display>
        <div class="que-name">
          <span translate>header.viewAnswers.questionnaireApproval</span>:
          {{ data.name }}
        </div>
      </div>
  </div>

  <div class="body">
    

    <div *ngIf="data.type == enum.Rejected" class="comment">
      <p class="text" translate>header.viewAnswers.rejectReason</p>

      <textarea
        class="comment-input"
        [placeholder]="'header.viewAnswers.rejectReasonPlaceholder' | translate"
        [formControl]="commentControl">
      </textarea>
    </div>
  </div>

  <div>
    <div class="divider"></div>
  </div>

  <div class="footer">
    <div class="btns">
      <button type="button" class="cancel pointer" (click)="close()">
        <p translate>header.viewAnswers.cancel</p>
      </button>

      <button type="button" class="save pointer" (click)="confirm()" [disabled]="isSubmitDisabled">
        <p translate>header.viewAnswers.send</p>
      </button>
    </div>
  </div>
</div>